module.exports = __webpack_public_path__ + "img/stamp_pc.35f2c328.svg";